import { route } from 'preact-router';
import { replaceInitialSalesAppRoute } from '../../partial/container/salesAppContainer';
const saRoute = (path, singleFunctionality, replace = false) => {
  return singleFunctionality
    ? replaceInitialSalesAppRoute(path)
    : route(path, replace);
};

export default saRoute;



// WEBPACK FOOTER //
// ./components/salesApp/constants/saRoute.js